import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import {
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom'
import './assets/css/index.css'

import Navbar from './components/navbar'
import ErrorPage from './components/errorPage'
import Dashboard from './pages/dashboard'
import Articulation from "./pages/articulation"
import BilanRetraite from './pages/bilan'
import StrategieRetraite from './pages/strategy'
import Optimisations from './pages/optimisation'
import Liquidation from './pages/liquidation'
import Conference from './pages/conference'
import Expatriation from './pages/expatriation'
import Contact from './pages/contact'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navbar />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
      {
        path: "nos-expertes",
        element: <Contact />
      },
      {
        path: "articulation-chomage-retraite",
        element: <Articulation />
      },
      {
        path: "bilan-retraite",
        element: <BilanRetraite />
      },
      {
        path: "strategie-retraite",
        element: <StrategieRetraite />
      },
      {
        path: "solutions-optimisation",
        element: <Optimisations />
      },
      {
        path: "liquidations-retraite",
        element: <Liquidation />
      },
      {
        path: "nos-conferences",
        element: <Conference />
      },
      {
        path: "retour-expatriation",
        element: <Expatriation />
      },      
    ],
  },
])

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
)